export default "__VITE_ASSET__a2IAQ_o6__"